<template>
  <div class="taskListBlock">
    <h1>TASK LIST</h1>
    <TaskForm/>
    <ul class="tableBlock">
      <li v-for="task in tasks" :key="task.id" class="liStyle">
        <div v-if="task.editing">
          <input type="text" v-model="task.title" @keyup.enter="saveTask(task)" @blur="saveTask(task)">
        </div>
        <div v-else>
          <span class="textList">{{ task.title }}</span>
        </div>
        <div class="btnControl">
          <button @click="deleteTask(task)" class="btnDel">Delete</button>
          <button @click="editTask(task)" class="btnEdit" >Edit</button>
        </div>

      </li>
    </ul>
  </div>
</template>

<script>
import TaskForm from "./TaskForm.vue";

export default {
  name: "TaskList",
  components: {
    TaskForm,
  },
  computed: {
    tasks() {
      return this.$store.state.tasks;
    },
  },
  methods: {
    deleteTask(task) {
      this.$store.commit("deleteTask", task);
    },
    editTask(task) {
      this.$store.commit("editTask", task);
    },
    saveTask(task){
      this.$store.commit("saveTask", task)
    }
  },
}
</script>

<style>
.taskListBlock {
  display: flex;
  flex-direction: column;
  align-items: center;
}
h1{
  color: darkblue;
  font-family: "Comic Sans MS",'cairo', serif;
  text-shadow: #FC0 1px 0 10px;
}
.tableBlock {
  width: 350px;
  list-style-type: none;
  padding: 0;
}

.liStyle {
  border: 2px #00ffd5 solid;
  border-radius: 9px;
  display: flex;
  margin: 4px;
  min-width: 100%;
  align-items: center;
  padding-left: 5px;
  word-break: break-all;
}

.btnControl {
  margin-left: auto;
  width: 130px;
}
.btnEdit{
  margin: 5px;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  background: cornflowerblue;
  color: white;
  :hover{
    cursor: pointer;
    filter: brightness(130%);
  }
}

.btnDel{
  margin: 5px;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  background: indianred;
  color: white;
  :hover{
    cursor: pointer;
    filter: brightness(130%);
  }
}
.textList{
  color: darkblue;
  font-family: "Comic Sans MS",'cairo', serif;
}
</style>